import { NAVBAR_ID } from '../../Navbar/constants';

export const enableGlobalScrollbar = () => {
  document.body.style.overflow = 'unset';
  document.querySelector('html')?.style.setProperty('scrollbar-gutter', 'unset');
  document.querySelector<HTMLElement>(`#${NAVBAR_ID}`)?.style.setProperty('overflow-y', 'unset');
};
